import { Component } from '@angular/core';
import { ORCIDRecordEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Records') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidrecord-form',
    templateUrl: './orcidrecord.form.component.html'
})
export class ORCIDRecordFormComponent extends BaseFormComponent {
    public record!: ORCIDRecordEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'educations', sectionName: 'Educations', isExpanded: false },
            { sectionKey: 'peerReviews', sectionName: 'Peer Reviews', isExpanded: false },
            { sectionKey: 'distinctions', sectionName: 'Distinctions', isExpanded: false },
            { sectionKey: 'fundings', sectionName: 'Fundings', isExpanded: false },
            { sectionKey: 'researcherUrls', sectionName: 'Researcher Urls', isExpanded: false },
            { sectionKey: 'works', sectionName: 'Works', isExpanded: false },
            { sectionKey: 'qualifications', sectionName: 'Qualifications', isExpanded: false },
            { sectionKey: 'researchResources', sectionName: 'Research Resources', isExpanded: false },
            { sectionKey: 'services', sectionName: 'Services', isExpanded: false },
            { sectionKey: 'invitedPositions', sectionName: 'Invited Positions', isExpanded: false },
            { sectionKey: 'memberships', sectionName: 'Memberships', isExpanded: false },
            { sectionKey: 'addresses', sectionName: 'Addresses', isExpanded: false },
            { sectionKey: 'emails', sectionName: 'Emails', isExpanded: false },
            { sectionKey: 'externalIdentifiers', sectionName: 'External Identifiers', isExpanded: false },
            { sectionKey: 'employments', sectionName: 'Employments', isExpanded: false },
            { sectionKey: 'otherNames', sectionName: 'Other Names', isExpanded: false },
            { sectionKey: 'recordLinks', sectionName: 'Record Links', isExpanded: false },
            { sectionKey: 'keywords', sectionName: 'Keywords', isExpanded: false }
        ]);
    }
}

